<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/pegawai-list-custom">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Prediksi KGB
        </li>
      </ol>
    </nav>

    <div class="content-block">
      <h5>Daftar Prediksi KGB</h5>
    </div>

    <LogPopupTemplate ref="logPopup" />
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          :focused-row-enabled="true"
          ref="dataGrid"
          :data-source="kgbPrediksiListStore.dataSourceKgbPrediksiList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          @context-menu-preparing="onContextMenuPreparing($event)"
        >
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
          />
          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxColumnFixing :enabled="true" />
          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            data-type="number"
            caption="Opsi"
            :allow-exporting="false"
            :allow-edititng="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="getOptions(data)"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
          <!-- <DxColumn
            caption="pegawaiID"
            data-field="pegawai_id"
            data-type="number"
          /> -->

          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />
          <DxColumn
            data-type="string"
            data-field="simpeg_pegawais_nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
          >
          </DxColumn>

          <DxColumn
            data-field="simpeg_pegawais_nama"
            caption="Nama"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
            :min-width="200"
          >
          </DxColumn>
          <DxColumn
            dataField="status_aktifs_nama"
            caption="Status Aktif"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.statusAktifSource }"
            :fixed="true"
            fixed-position="left"
          />
          <DxColumn
            data-field="simpeg_pegawais_tgl_mulai_bekerja"
            caption="Tgl Mulai Bekerja"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
          >
          </DxColumn>
          <DxColumn
            data-field="simpeg_kgbs_tgl"
            caption="Tgl KGB Terakhir"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
          />
          <DxColumn
            data-field="simpeg_kgbs_masa_kerja"
            caption="MK Terakhir (Tahun)"
            :allowHeaderFiltering="false"
            :customize-text="commonFunction.appendTahun"
          />
          <DxColumn
            data-field="simpeg_kgbs_masa_kerja_bulan"
            caption="MK Terakhir (Bulan)"
            :allowHeaderFiltering="false"
            :customize-text="commonFunction.appendBulan"
          />
          <DxColumn
            data-field="gaji_pokok_kgb_jml"
            caption="Gaji Pokok Terakhir"
            :allowHeaderFiltering="false"
            data-type="number"
            :customize-text="commonFunction.formatNumberWithDots"
          ></DxColumn>

          <DxColumn
            data-field="simpeg_kgb_prediksis_tgl"
            caption="Prediksi Tgl KGB Selanjutnya"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
            css-class="cell-highlighted"
          />

          <DxColumn
            data-field="simpeg_kgb_prediksis_masa_kerja"
            caption="Prediksi MK Selanjutnya (Tahun)"
            :allowHeaderFiltering="false"
            css-class="cell-highlighted"
            :customize-text="commonFunction.appendTahun"
          />
          <DxColumn
            data-field="simpeg_kgb_prediksis_masa_kerja_bulan"
            caption="Prediksi MK Selanjutnya (Bulan)"
            :allowHeaderFiltering="false"
            css-class="cell-highlighted"
            :customize-text="commonFunction.appendBulan"
          />
          <DxColumn
            data-field="gaji_pokok_prediksi_jml"
            caption="Prediksi Gaji Pokok Selanjutnya"
            :allowHeaderFiltering="false"
            data-type="number"
            :customize-text="commonFunction.formatNumberWithDots"
            css-class="cell-highlighted"
          ></DxColumn>

          <DxColumn
            caption="Prediksi dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Prediksi diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import * as commonFunction from "@/utils/common-function.js";
import { BASE_URL } from "@/global-constants";
import StatusTemplate from "./StatusTemplate.vue";
import { useKgbPrediksiListStore } from "@/stores/views/kgb-prediksi-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";

import DxButton from "devextreme-vue/button";
// import { DateTime } from "luxon";
import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";

/* eslint-disable */
export default {
  components: {
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    StatusTemplate,
    LogPopupTemplate,
  },
  setup() {
    const kgbPrediksiListStore = useKgbPrediksiListStore();
    const commonStore = useCommonStore();
    kgbPrediksiListStore.dataSourceKgbPrediksiList.filter(null);

    return {
      kgbPrediksiListStore,
      commonStore,
      commonFunction,
    };
  },
  data() {
    const vm = this;
    return {
      logPopupRef: null,
      serverUrl: `${BASE_URL}/`,
      fileUrl: null,
      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,
    };
  },

  async created() {
    this.kgbPrediksiListStore.dataSourceKgbPrediksiList.filter(null);
    await this.commonStore.preloadStores();
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    getOptions(data) {
      return [
        {
          text: "Detail Pegawai",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        {
          text: "Absensi",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        {
          text: "Riwayat Gaji",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        {
          text: "Log Perubahan Data",
          pegawai_id: data.data.pegawai_id,
          row_key: data.key,
        },
        // other options...
      ];
    },
    displayCapeg(e) {
      if (e.value) {
        return "80%";
      }
    },
    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },
    handleClickDocument(e) {
      console.log("debug handleclickdocument");
      if (e.data.file_path !== null)
        window.open(
          this.serverUrl + e.data.file_path,
          "_blank",
          "location=yes",
        );
    },

    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },
    onContextMenuPreparing(e) {
      console.log("onContextMenuPreparing", e);
      if (e.target == "content") {
        e.itemData = {
          pegawai_id: e.row.data.pegawai_id,
          row_key: e.row.data.id,
        };

        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];
        e.items.push({
          text: "Lihat Detail Pegawai",
          icon: "user",
          onItemClick: () => {
            e.itemData.text = "Detail Pegawai";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Lihat Absensi",
          icon: "event",
          onItemClick: () => {
            e.itemData.text = "Absensi";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Riwayat Gaji",
          icon: "money",
          onItemClick: () => {
            e.itemData.text = "Riwayat Gaji";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Log Perubahan Data",
          icon: "clock",
          onItemClick: () => {
            e.itemData.text = "Log Perubahan Data";
            this.$refs.logPopup.showBySubject(e.row.key, "SimpegKgbPrediksi");
          },
        });
      }
    },
    onItemClick(e) {
      const pegawaiId = e.itemData.pegawai_id;
      const rowKey = e.itemData.row_key;

      if (e.itemData.text === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["absen_bulans_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Log Perubahan Data") {
        this.$refs.logPopup.showBySubject(rowKey, "SimpegKgbPrediksi");
      }
    },

    can,

    refreshDatagrid(gridRef) {
      this.kgbPrediksiListStore.dataSourceKgbPrediksiList.filter(null);
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Absen");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Prediksi KGB.xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
